var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.discount_percentage)?_c('div',{staticClass:"rate-deal"},[_c('vb-icon',{staticClass:"mr-1",attrs:{"name":'tags',"color":_vm.sass('success'),"size":14}}),_c('span',[_vm._v(_vm._s(_vm.discount_percentage)+"% di sconto")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }